import { createStructuredSelector } from 'reselect';

export const selectGrantsOverviewStates = (state) => state.grantsDashboard;

// select updated counter data
export const selectUpdatedCountData = (state) => {
  const { searchLoadMoreApi } = selectGrantsOverviewStates(state);
  return searchLoadMoreApi;
};

// select search charity data
export const selectSearchCharityData = (state) => {
  const { searchCharity } = selectGrantsOverviewStates(state);
  return searchCharity.data;
};

// select charitySaved data
export const selectCharitySavedData = (state) => {
  const { charitySaved } = selectGrantsOverviewStates(state);
  return charitySaved;
};

export const searchTableState = createStructuredSelector({
  updatedCounterData: selectUpdatedCountData,
  updatedSearchData: selectSearchCharityData,
  charitySaved: selectCharitySavedData,
});
